module.exports = __webpack_public_path__ + "static/img/show_pic6.d1166f0f.png";